import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Dialog from "@/view/components/Dialog";
import { DELETE } from "@/core/services/store/request.module";
export default {
  name: "delete-confirmation",
  props: {
    deleteDialog: {
      type: Boolean,
      default: false
    },
    isBin: {
      type: Boolean,
      default: false
    },
    toBeDelete: {
      type: Object,
      default: function _default() {
        return {
          uuid: null,
          type: null,
          name: null,
          created: {
            datetime: null
          }
        };
      }
    }
  },
  components: {
    "delete-dialog": Dialog
  },
  watch: {
    isBin: function isBin(param) {
      if (param) {
        this.permanent_delete = 1;
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      permanent_delete: 0
    };
  },
  methods: {
    delete_file: function delete_file() {
      var _this = this;

      this.loading = true;
      this.$store.dispatch(DELETE, {
        url: "files/".concat(this.toBeDelete.uuid, "/delete?permanent=").concat(this.permanent_delete)
      }).then(function () {
        _this.$emit("close", true);

        _this.$emit("success", true);
      }).catch(function (error) {
        console.log({
          error: error
        });
      }).finally(function () {
        _this.loading = false;
      });
    }
  },
  mounted: function mounted() {
    if (this.isBin) {
      this.permanent_delete = 1;
    }
  }
};